import customFormData from "./custom-form-data";

const { general, clock, spots, scoring } = customFormData;

const indoorCustomFormData = {
    general: {
        ...general,
        fieldLength: {
            ...general.fieldLength,
            icon: "indoor-football"
        },
        fieldWidth: {
            ...general.fieldWidth,
            icon: "indoor-football"
        },
        endZoneLength: {
            ...general.endZoneLength,
            icon: "indoor-football"
        },
        promptToSkipKickoff: {
            disabled: true
        }
    },
    clock,
    spots: {
        ...spots,
        kickoff: {
            ...spots.kickoff,
            icon: "indoor-football"
        },
        KOTouchback: {
            ...spots.KOTouchback,
            icon: "indoor-football"
        },
        touchbackYardline: {
            ...spots.touchbackYardline,
            icon: "indoor-football"
        },
        rougeYardline: {
            ...spots.rougeYardline,
            icon: "indoor-football"
        },
        safetyKO: {
            ...spots.safetyKO,
            icon: "indoor-football"
        },
        // Indoor-only spot. Title matches what fromCamelCase already
        // produced, so the field renders exactly as before - the entry exists
        // only to carry the definition. No league badge: adding one would be
        // a visual change this ticket was not asked to make.
        kickoffOutOfBounds: {
            title: "Kickoff Out Of Bounds",
            description:
                "Spot where the ball is placed following a kickoff that goes out of bounds."
        },
        goalPostLocation: {
            ...spots.goalPostLocation,
            icon: "indoor-football"
        }
    },
    scoring: {
        ...scoring,
        dropKickFieldGoal: {
            title: "Drop Kick Field Goal",
            icon: "indoor-football",
            description:
                "Number of points awarded in case of a successful drop kick."
        },
        dropKickPAT: {
            title: "Drop Kick PAT",
            icon: "indoor-football",
            description:
                "Number of points awarded in case of a point after attempt that is drop kicked."
        },
        deuce: {
            title: "Deuce Score",
            icon: "indoor-football",
            description: "Number of points awarded for a deuce."
        }
    }
};

export default indoorCustomFormData;
